"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _download = _interopRequireDefault(require("../../assets/download"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var DownloadBox = function DownloadBox(_ref) {
  var href = _ref.href,
      className = _ref.className,
      thumbnail = _ref.thumbnail,
      filename = _ref.filename,
      otherProps = _objectWithoutProperties(_ref, ["href", "className", "thumbnail", "filename"]);

  var bytesToMega = function bytesToMega(value) {
    var val = value > 10000 ? "".concat((value / 1000000).toFixed(2), " mb") : "".concat((value / 1000).toFixed(2), " kb");
    return val;
  };

  var calculateImageSize = function calculateImageSize(base64String) {
    var padding, inBytes, base64StringLength;
    if (base64String.endsWith('==')) padding = 2;else if (base64String.endsWith('=')) padding = 1;else padding = 0;
    base64StringLength = base64String.length;
    inBytes = base64StringLength / 4 * 3 - padding;
    return bytesToMega(inBytes);
  };

  return /*#__PURE__*/_react.default.createElement(Download, _extends({
    className: className
  }, otherProps), /*#__PURE__*/_react.default.createElement("a", {
    href: href,
    target: "_blank",
    rel: "noopener noreferrer",
    thumbnail: thumbnail
  }, thumbnail ? /*#__PURE__*/_react.default.createElement(Thumbnail, {
    src: thumbnail,
    alt: "download"
  }) : null, /*#__PURE__*/_react.default.createElement(Container, {
    thumbnail: thumbnail
  }, /*#__PURE__*/_react.default.createElement(FileName, null, filename, " "), /*#__PURE__*/_react.default.createElement(FileSize, null, calculateImageSize(href))), /*#__PURE__*/_react.default.createElement(DownloadIcon, null)));
};

var Download = _styledComponents.default.div.withConfig({
  displayName: "Download"
})(["width:30rem;border:0.1rem solid #f0f1f3;box-shadow:0 2px 5px rgba(0,0,0,0.05);border-radius:5px;padding:0.8rem 2.4rem 0.8rem 1.6rem;& a{display:flex;width:100%;align-items:center;text-decoration:none;font-family:", ";font-size:1.4rem;line-height:120%;}"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.font;
});

var FileName = _styledComponents.default.span.withConfig({
  displayName: "FileName"
})(["font-weight:500;color:", ";margin-right:1.5rem;"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.typo.text;
});

var FileSize = _styledComponents.default.span.withConfig({
  displayName: "FileSize"
})(["font-weight:normal;color:", ";"], function (_ref4) {
  var theme = _ref4.theme;
  return theme.typo.interactive;
});

var Container = _styledComponents.default.span.withConfig({
  displayName: "Container"
})(["display:flex;", ""], function (props) {
  return props.thumbnail ? 'flex-direction: column;' : 'flex-direction: row;';
});

var DownloadIcon = (0, _styledComponents.default)(_download.default).withConfig({
  displayName: "DownloadIcon"
})(["margin-left:auto;"]);

var Thumbnail = _styledComponents.default.img.withConfig({
  displayName: "Thumbnail"
})(["width:5rem;height:5rem;padding-top:0.5rem;padding-bottom:0.5rem;margin-right:1.5rem;"]);

DownloadBox.defaultProps = {
  thumbnail: ''
};
DownloadBox.propTypes = {
  /** Beeing able to use it in Styled Components */
  className: _propTypes.string,

  /** base64 string to download file and get the filesize */
  href: _propTypes.string,

  /** string with the name of the file */
  filename: _propTypes.string,

  /** option to show a thumbnail image of the file*/
  thumbnail: _propTypes.string,

  /** Adds extra props to the element */
  otherProps: _propTypes.object
};
var _default = DownloadBox;
exports.default = _default;